@import 'styles/mixins';
@import 'styles/variables';

.separator {
  border-top: 1px solid var(--neutral-10);
  margin: 4px;

  [data-design-system='blaze'] & {
    border-top: 1px solid var(--dark-4);
  }
}
